import * as yup from "yup";

// FORM-02: boron の保存時バリデーション・Lambda ドメインバリデーション（指示文 3000 文字）と一致させる
export const PROMPT_MAX_LENGTH = 3000;

export interface StudentFollowPromptFormValues {
  prompt: string;
}

// FORM-04: 空文字での登録 = 未設定化は正常系のため required を付けない
const validationSchema = yup.object().shape({
  prompt: yup
    .string()
    .max(
      PROMPT_MAX_LENGTH,
      `プロンプトは${PROMPT_MAX_LENGTH}文字以下で入力してください`,
    ),
});

export default validationSchema;
